{
  "title": "إدارة السنوات",
  "passwordGate": {
    "title": "إعادة إدخال كلمة المرور",
    "description": "لعرض إدارة السنوات، أدخل كلمة مرورك.",
    "label": "كلمة المرور",
    "submit": "متابعة"
  },
  "frozenBanner": "النظام مجمد مؤقتا لعملية إدارة السنوات",
  "columns": {
    "year": "السنة",
    "backup": "النسخة الاحتياطية",
    "archive": "الترحيل إلى الأرشيف",
    "reset": "تصفير السنة"
  },
  "status": {
    "verified": "موثقة",
    "notDone": "لم تتم",
    "running": "جارية...",
    "failed": "فشلت"
  },
  "actions": {
    "backup": "تنزيل نسخة احتياطية",
    "archive": "ترحيل السنة إلى الأرشيف",
    "reset": "تصفير السنة",
    "download": "تنزيل"
  },
  "operationsHistory": {
    "title": "سجل العمليات",
    "empty": "لا توجد عمليات بعد",
    "columns": {
      "year": "السنة",
      "kind": "النوع",
      "status": "الحالة",
      "startedBy": "بدأها",
      "startedAt": "بدأت في",
      "finishedAt": "انتهت في",
      "sha256": "البصمة (SHA-256)"
    }
  },
  "kind": {
    "BACKUP": "نسخة احتياطية",
    "ARCHIVE_MIGRATION": "ترحيل إلى الأرشيف",
    "RESET": "تصفير"
  },
  "opStatus": {
    "RUNNING": "جارية",
    "SUCCEEDED": "نجحت",
    "FAILED": "فشلت"
  },
  "confirm": {
    "passwordLabel": "كلمة المرور",
    "backupTitle": "تنزيل نسخة احتياطية من سنة {{year}}؟",
    "backupDescription": "سيتم إنشاء نسخة احتياطية كاملة من قاعدة البيانات لسنة {{year}} مع بصمة للتحقق. يمكن إعادة تنزيلها لاحقا.",
    "backupConfirm": "تنزيل",
    "archiveTitle": "ترحيل سنة {{year}} إلى الأرشيف؟",
    "archiveDescription": "سيتم نسخ سجلات سنة {{year}} إلى الأرشيف والتحقق من صحتها.",
    "archiveConfirm": "ترحيل",
    "resetTitle": "تصفير سنة {{year}}؟",
    "resetDescription": "تؤرشف حركات سنة {{year}} وتحذف من النظام. يبقى كما هو: المستخدمون والمجموعات والخدمات والإعدادات والتصنيفات والتواريخ. ترحل أرصدة المدينين كرصيد افتتاحي.",
    "resetConfirm": "تصفير",
    "resetDisabledReason": "يتطلب نسخة احتياطية موثقة وترحيلا موثقا إلى الأرشيف لهذه السنة أولا"
  },
  "download": {
    "title": "تنزيل النسخة الاحتياطية",
    "description": "أدخل كلمة مرورك لتنزيل هذه النسخة الاحتياطية.",
    "confirm": "تنزيل"
  },
  "toasts": {
    "backupStarted": "بدأ إنشاء النسخة الاحتياطية",
    "archiveStarted": "بدأ الترحيل إلى الأرشيف",
    "resetStarted": "بدأت عملية التصفير",
    "operationSucceeded": "اكتملت العملية بنجاح",
    "operationFailed": "فشلت العملية"
  }
}
